import { css } from 'emotion';

export const transitionGroup = css(`
	display: flex;
	width: 100%;
`);

export const content = css(`
	width: 100%;
`);
